export default __webpack_public_path__ + "static/hsc2025resultscrop-f72681f3b9e5bb7556a81e9b7e7a8f47.png";